import React, { useEffect, useState, useMemo } from "react";
import Navbar from "../../../Navbar";
import { logEventos } from "../../../../services/services";
import {
  Container,
  Typography,
  ListItemIcon,
  Button,
  Tooltip,
  MenuItem,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { Delete } from "@mui/icons-material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { getData, putData } from "../../../../services/library";
import AltaGrupo from "./alta/AltaGrupo";
import BajaGrupo from "./baja/BajaGrupo";
import EdicionGrupo from "./edicion/EdicionGrupo";
import MarcarActivoGrupo from "./activo/MarcarActivoGrupo";
import MapIcon from "@mui/icons-material/Map";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import BlockIcon from "@mui/icons-material/Block";
import ZonasGeograficas from "./zonas/ZonasGeograficas";
import GeoZonas from "../GeoZonas";

function GruposGeograficos() {
  const [choferZona, setChoferZona] = useState(false);
  const [verZonas, setVerZonas] = useState(false);
  const [verGeoZonas, setVerGeoZonas] = useState(false);
  const [grupos, setGrupos] = useState();
  const [alta, setAlta] = useState(false);
  const [tabla, setTabla] = useState(true); 
  const [editar, setEditar] = useState(false); 
  const [baja, setBaja] = useState(false); 
  const [dataGrupo, setDataGrupo] = useState({});
  const [marcarActivo, setMarcarActivo] = useState(false);
  const [notify, setNotify] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  //Tabla
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);

  //  Funcion para traer los clientes a la tabla : ACTIVOS
  const obtenerGruposInactivos = () => {
    setHiddenmuestrainactivo(true);
    setHiddenmuestraactivos(false);
    getData("/envasado_grupos_zonas/inactivos", setGrupos);
  };

  const obtenerGrupos = () => {
    setHiddenmuestraactivos(true);
    setHiddenmuestrainactivo(false);
    getData("/envasado_grupos_zonas/", setGrupos);
  };

  useEffect(() => {
    obtenerGrupos();
  }, [tabla]);

  const handleClickNuevo = () => {
    setAlta(true); 
  };

  const handleCloseEditar = () => {
    setEditar(false);
    setTabla(true);
    obtenerGrupos();
  };
  const handleCloseAlta = () => {
    setAlta(false);
    setTabla(true);
    obtenerGrupos();
  };
  const handleCloseVerZonas = () => {
    setVerZonas(false);
    setTabla(true);
    obtenerGrupos();
  };
  const handleCloseVerGeoZonas = () => {
    setVerGeoZonas(false);
    setTabla(true);
    obtenerGrupos();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id", //access nested data with dot notation
        header: "ID",
        maxSize: 100,
      },
      {
        accessorKey: "nombre", //access nested data with dot notation
        header: "Nombre",
        maxSize: 100,
      },
      {
        accessorKey: "descripcion", //access nested data with dot notation
        header: "Descripción",
      },
      {
        accessorKey: "nombre_localidad", //access nested data with dot notation
        header: "Localidad",
      },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  };

  useEffect(() => {
    logEventos(
      "acceso al menú Grupos Geográficos",
      "Envasado",
      "Grupos Geográficos",
      localStorage.getItem("user")
    );
  }, []);

  return (
    <>
      {tabla && <Navbar />}
      <Container maxWidth="xl" disableGutters sx={{ mb: 2 }}>
        {tabla && (
          <MaterialReactTable
            localization={MRT_Localization_ES}
            columns={columns}
            data={grupos ?? [{}]}
            layoutMode={"grid"}
            initialState={initialState}
            enableColumnActions={false} //deshabilita las acciones POR COLUMNA
            enableGlobalFilterModes={false}
            enableHiding={false}
            enableRowActions={true}
            enableColumnFilters={false}
            enableFullScreenToggle={false}
            positionActionsColumn={"last"}
            enableExpandAll={false}
            enableToolbarInternalActions={true}
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            enableDensityToggle={false}
            displayColumnDefOptions={displayColumnDefOptions}
            enableColumnResizing={true}
            muiTableBodyCellProps={({ row }) => ({
              align: "left",
              sx: {
                backgroundColor:
                  row.original.activo === 1 ? "#b3e6b3" : "#efc3c3",
                color: "black",
              },
            })}
            renderTopToolbarCustomActions={(row, table) => (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddBoxTwoToneIcon color="asd" />}
                  onClick={handleClickNuevo}
                >
                  Nuevo Grupo
                </Button>
                <Typography variant="poster" fontSize={26}>
                  <MapIcon sx={{ fontSize: 20 }} />
                  Grupos Geográficos
                </Typography>
              </>
            )}
            renderToolbarInternalActions={(row, table) => (
              <>
                {!hiddenmuestrainactivo ? (
                  <Tooltip title="Muestra Inactivos">
                    <IconButton
                      onClick={() => obtenerGruposInactivos()}
                      color="error"
                    >
                      <BlockIcon />
                    </IconButton>
                  </Tooltip>
                ) : null}
                {!hiddenmuestraactivos ? (
                  <Tooltip title="Mostrar ACTIVOS" color="success">
                    <IconButton onClick={() => obtenerGrupos()}>
                      <CheckCircleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                ) : null}
              </>
            )}
            renderRowActionMenuItems={({ closeMenu, row, index }) => [
              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? null : "none",
                }}
                disabled={row.original.activo === 1}
                onClick={() => {
                  setMarcarActivo(true);
                  setDataGrupo(row.original);
                  closeMenu();
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <CheckCircleOutlineIcon color="success" />
                </ListItemIcon>
                Marcar Activo
              </MenuItem>,

              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? "none" : null,
                }}
                disabled={row.original.activo === 0}
                onClick={() => {
                  closeMenu();
                  setDataGrupo(row.original);
                  setEditar(true);
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <BorderColorIcon color="primary" />
                </ListItemIcon>
                Editar
              </MenuItem>,

              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? "none" : null,
                }}
                disabled={row.original.activo === 0}
                onClick={() => {
                  closeMenu();
                  setDataGrupo(row.original);
                  setVerZonas(true);
                  setTabla(false);
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <AddLocationAltIcon color="primary" />
                </ListItemIcon>
                Ver Zonas
              </MenuItem>,

              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? "none" : null,
                }}
                disabled={row.original.activo === 0}
                onClick={() => {
                  closeMenu();
                  setDataGrupo(row.original);
                  setBaja(true);
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <Delete color="error" />
                </ListItemIcon>
                Marcar Inactivo
              </MenuItem>,
              <MenuItem
                key={index}
                style={{
                  display: row.original.activo === 0 ? "none" : null,
                }}
                disabled={row.original.activo === 0}
                onClick={() => {
                  closeMenu();
                  setDataGrupo(row.original);
                  setVerGeoZonas(true);
                  setTabla(false);
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <AddLocationAltIcon color="primary" />
                </ListItemIcon>
                Geo Zonas
              </MenuItem>,
            ]}
          />
        )}
        {baja && (
          <BajaGrupo
            open={baja}
            setOpen={setBaja}
            grupo={dataGrupo}
            tabla={setTabla}
            actualizar={obtenerGrupos}
          />
        )}
        {editar ? (
          <EdicionGrupo
            editar={editar}
            datosRow={dataGrupo}
            onClose={() => handleCloseEditar(false)}
          />
        ) : null}
        {alta ? (
          <AltaGrupo alta={alta} onClose={() => handleCloseAlta(false)} />
        ) : null}
        {marcarActivo ? (
          <MarcarActivoGrupo
            open={marcarActivo}
            setOpen={setMarcarActivo}
            grupo={dataGrupo}
            tabla={setTabla}
            actualizar={obtenerGrupos}
          />
        ) : null}
        {verZonas ? (
          <ZonasGeograficas
            dataGrupo={dataGrupo}
            onClose={() => handleCloseVerZonas()}
          />
        ) : null}
        {verGeoZonas ? (
          <GeoZonas
            dataGrupo={dataGrupo}
            onClose={() => handleCloseVerGeoZonas()}
          />
        ) : null}
      </Container>
    </>
  );
}

export default GruposGeograficos;
